export default "/images/vendor/flag-icon-css/flags/4x3/ss.svg?e4bf9bb42bd5d25190fee9dfdd245c76";